import apiClient from '@/api/apiClient';

export default {
    // 旧入口: 按时间窗口拉取相关会话 + 消息. 兼容保留.
    getMessages(fromTime, toTime, merchantID) {
        return apiClient.get("/api/customer/app/message", {params: {fromTime, toTime, merchantID}});
    },
    // 新入口: 仅拉取会话元数据(无消息), 用于侧边栏"最近联系人".
    getConversations() {
        return apiClient.get("/api/customer/app/conversations");
    },
    // 新入口: 拉取指定会话最近 limit 条消息(默认 300, 由后端兜底).
    getMessagesByConversation(conversationId, limit) {
        return apiClient.get("/api/customer/app/conversation/messages", {
            params: {conversationId, limit}
        });
    },
    setMessagesRead(toUid, merchantID) {
        return apiClient.post("/api/customer/app/message/read", {toUid, merchantID});
    },
    // 推进会话已读游标 (POST /conversation/read). 幂等; 仅向前推进.
    markConversationRead(conversationId, lastReadMessageId) {
        return apiClient.post("/api/customer/app/conversation/read", {
            conversationId, lastReadMessageId
        });
    },
    // 按 merchantId 查公司名: 后端只返回 {merchantId, companyName}.
    // 用于访客首次打开某商户聊天且尚未有会话时, 把侧边栏 fallback 名替换成真实名称.
    getMerchantInfo(merchantId) {
        return apiClient.get("/api/customer/app/merchant/info", {params: {merchantId}});
    }

};
